import Store from 'redux/store';
import {
  FETCH_TAGS_FAIL,
  FETCH_TAGS_SUCCESS,
} from 'redux/Reducers/Tag/TagReducer';
import { tagEndpoint } from '../clients';
import { fetchFromCacheOrAPI } from '../fetchFromCacheOrAPI';
import PipeProviderStateSingleton from '../../Providers/PipeProvider/PipeProviderState.singleton';
import generateUUID from '../../../Utils/generateUUID';

/* eslint-disable */
const PipeSingleton = new PipeProviderStateSingleton()
const fetchTagsAPI = async (User, sku, name, callback) => {
  try {
    const response = await tagEndpoint(User).get(`/${sku}`);
    if (callback) callback({[sku]: FormatTagOBJ([{
        response, sku
      }])[0]
    });
    PipeSingleton.appendInGroupResponse('TAG_GROUP', name, { response, sku })
    return response;
  } catch (e) {
    throw e;
  }
};

const FormatTagOBJ = (tagsResponse = []) => {
  const skusData = tagsResponse.map(({ response: { data }, sku }) => ({
    sku,
    expirationDate: data[0] && data[0].endDate || null,
    data: data.map(tagResult => ({
      label: tagResult.tag,
      textColor: tagResult.textColor,
      backgroundColor: tagResult.backgroundColor,
    })),
  }))

  return skusData;
}

const processTags = (tagsResponse) => {
  if (tagsResponse && tagsResponse.length) {
    const data = FormatTagOBJ(tagsResponse)
    Store.dispatch({
      type: FETCH_TAGS_SUCCESS,
      payload: {
        data,
      },
    });
  }
};

PipeSingleton.addReturnCallbackGroup('TAG_GROUP', (responses) => {
  processTags(responses);
})


const handleTagAddRequest = () => {
  const name = generateUUID()
  PipeSingleton.appendInGroupRequest('TAG_GROUP', name);
  return name;
}

const FetchTag = async (User, finallyCallback = () => {}, { sku, callback }) => {
  const name = handleTagAddRequest()
  try {
    await fetchFromCacheOrAPI(`FETCH_TAGS_${sku}`, () => fetchTagsAPI(User, sku, name, callback));
  } catch (e) {
    Store.dispatch({
      type: FETCH_TAGS_FAIL,
      error: e,
      sku,
    });
  } finally {
    PipeSingleton.executeCallbackForGroup('TAG_GROUP', () => {
      finallyCallback();
    })
  }
};


export default FetchTag;
